// index.tsx
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableNonPagerProps } from "../../interface/index";

const Datatable: React.FC<DatatableNonPagerProps> = ({ columns, dataSource , Selection,onUpdate }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [Selections, setSelections] = useState<any>(true);
    const [filteredDataSource, setData] = useState(dataSource);

    const onSelectChange = (newSelectedRowKeys: any[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const handleChange = (new_list) => {
        onUpdate(new_list); // Calls the parent's onUpdate function
    };
    useEffect(() => {
            //setData([{id:'444'},{id:'555'},{id:'666'}]);
            setData(dataSource);
            return setSelections(Selection);
            }, [columns, dataSource , Selection])
    return (
            <>
            {!Selections ?
            <Table
            pagination={false}
            className="table datanew dataTable no-footer"
            columns={columns}
            rowHoverable={false}
            dataSource={filteredDataSource}
            /> :
            <Table
            pagination={false}
            className="table datanew dataTable no-footer"
            rowSelection={rowSelection}
            columns={columns}
            rowHoverable={false}
            dataSource={filteredDataSource}
            />}

            </>
                );
};

export default Datatable;
